import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import localePt from '@angular/common/locales/pt';

import { FeatureImgCloudModule } from '@unico-people/feature-img-cloud';

import { ItemCollaboratorComponent } from './item-collaborator.component';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule, FeatureImgCloudModule],
  declarations: [ItemCollaboratorComponent],
  exports: [ItemCollaboratorComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }]
})
export class ItemCollaboratorModule {}
